import { cn } from '@/lib/utils';
import { Switch as SwitchPrimitives } from 'radix-ui';
import { forwardRef } from 'react';

const HubertSwitch = forwardRef<
  React.ComponentRef<typeof SwitchPrimitives.Root>,
  React.ComponentPropsWithoutRef<typeof SwitchPrimitives.Root>
>(({ className, ...props }, ref) => (
  <SwitchPrimitives.Root
    className={cn(
      'peer inline-flex',
      'cursor-pointer',
      'h-5 w-10 shrink-0',
      'rounded-full border-2 border-transparent shadow-sm',
      'items-center transition-colors',
      'focus-visible:ring-ring focus-visible:ring-offset-background focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:outline-none',
      'disabled:cursor-not-allowed disabled:opacity-50',
      'data-[state=checked]:bg-primary data-[state=unchecked]:bg-input',
      className,
    )}
    {...props}
    ref={ref}
  >
    <SwitchPrimitives.Thumb
      className={cn(
        'pointer-events-none',
        'h-4 w-4',
        'block',
        'bg-white',
        'rounded-full',
        'shadow-lg ring-0 transition-transform',
        'data-[state=checked]:translate-x-5',
        'data-[state=unchecked]:translate-x-1',
      )}
    />
  </SwitchPrimitives.Root>
));

HubertSwitch.displayName = SwitchPrimitives.Root.displayName;

export default HubertSwitch;
